import {
  fork,
  takeLatest,
  call,
  put,
  all,
  select,
  delay,
} from "redux-saga/effects";
import {
  resetTimer,
  resetSubmitResult,
  setTimeLeft,
  fetchExamInstructionRequest,
  fetchExamInstructionSuccess,
  fetchExamInstructionFailure,
  fetchExamQuestionRequest,
  fetchExamQuestionSuccess,
  fetchExamQuestionFailure,
  fetchExamQuestionsListRequest,
  fetchExamQuestionsListSuccess,
  fetchExamQuestionsListFailure,
  saveAnswerRequest,
  saveAnswerSuccess,
  saveAnswerFailure,
  setCurrentQuestionIndex,
  setActiveSection,
  fetchPracticeListSuccess,
  fetchPracticeListFailure,
  fetchPracticeListRequest,
  submitExamRequest,
  submitExamSuccess,
  submitExamFailure,
  saveBookmarkRequest,
  saveBookmarkSuccess,
  saveBookmarkFailure,
  getPyqYearWiseSuccess,
  getPyqYearWiseFailure,
  getPyqYearWiseRequest,
  getPyqYearwisePapersSuccess,
  getPyqYearwisePapersFailure,
  getPyqYearwisePapersRequest,
  fetchSubjectListSuccess,
  fetchSubjectListFailure,
  fetchSubjectListRequest,
  getPyqTopicWiseSuccess,
  getPyqTopicWiseFailure,
  getPyqTopicWiseRequest,
  getPyqSubjectWiseSuccess,
  getPyqSubjectWiseFailure,
  getPyqSubjectWiseRequest,
  getPyqTopicWiseSetsSuccess,
  getPyqTopicWiseSetsFailure,
  getPyqTopicWiseSetsRequest,
  fetchPracticeSummaryRequest,
  fetchPracticeSummarySuccess,
  fetchPracticeSummaryFailure,
  setTestDetails,
  setPracticeStreak 
} from "./examSlice";
import {
  fetchBasicAnalyticsRequest,
  clearBasicAnalytics,
} from "../exam_analytics/analyticsSlice";

import examApi from "./examApi";

/* ------------------ FETCH INSTRUCTION ------------------ */
function* fetchExamInstructionWorker(action) {
  try {
    const response = yield call(examApi.getInstruction, action.payload);
    yield put(fetchExamInstructionSuccess(response.data));
  } catch (error) {
    yield put(fetchExamInstructionFailure(error.message));
  }
}

/* ------------------ FETCH SINGLE QUESTION ------------------ */
function* fetchExamQuestionWorker(action) {
  try {
    const { testType, testDetails, questionsData } = yield select(
      (state) => state.examSlice
    );

    const question = questionsData?.find((q) => q.qid === action.payload.qid);

    const response = yield call(examApi.getQuestion, {
      paperType: testType?.id,
      paperId: question?.paper_id,
      qid: action.payload.qid,
      testId: testDetails?.testId,
      setId: testDetails?.setId,
      plannerTestId: testDetails?.planner_test_id ?? null,
    });

    yield put(fetchExamQuestionSuccess(response.data));
  } catch (error) {
    yield put(fetchExamQuestionFailure(error.message));
  }
}

/* ------------------ FETCH QUESTIONS LIST ------------------ */
function* fetchExamQuestionsListWorker(action) {
  try {
    yield put(resetSubmitResult());

    // const { testDetails } = yield select((state) => state.examSlice);

    const response = yield call(examApi.getQuestionList, {
      ...action.payload,
      practiceMode: action.payload?.practiceMode,
      gamification_status:
        action.payload?.practiceMode === "practice" && action.payload?.gamificationOn
          ? 1
          : undefined,
    });

    yield put(fetchExamQuestionsListSuccess(response?.data));
    yield put(setTimeLeft(null)); 
    // const paperDuration = response?.data?.paper_duration || 10800;
    const state = yield select((state) => state.examSlice);
const paperDuration = state.paper_duration || 10800;

    const firstQuestion = response?.data?.data?.[0];

    const currentTestId =
  action.payload?.testId ||
  action.payload?.setId ||
  action.payload?.paperId;

const testKey = `exam_timeLeft_${currentTestId}`;
const isPracticeMode =
  action.payload?.practiceMode === "practice";

if (isPracticeMode) {
  //  Always start practice fresh from 0
  localStorage.removeItem(testKey);
  localStorage.setItem(testKey, "0");
  yield put(resetTimer(0));
} else {
  const storedTime = localStorage.getItem(testKey);

  if (storedTime) {
    yield put(setTimeLeft(Number(storedTime)));
  } else {
    localStorage.setItem(testKey, paperDuration.toString());
    yield put(resetTimer(paperDuration));
  }
}

    if (firstQuestion?.qid) {
      yield put(
        fetchExamQuestionRequest({
          qid: firstQuestion.qid,
          paperId: firstQuestion.paper_id,
          testId: currentTestId,
          setId: action.payload?.setId,
        })
      );
    }
  } catch (error) {
    yield put(fetchExamQuestionsListFailure(error.message));
  }
}

/* ------------------ SAVE ANSWER ------------------ */
function* saveAnswerWorker(action) {
  try {
    const state = yield select((state) => state.examSlice);

    const currentIndex = state.currentQuestionIndex;
    const currentQ = state.questionsData[currentIndex];
    const nextIndex = currentIndex + 1;

    const finalPayload = {
      ...action.payload,
      paper_id: currentQ?.paper_id,
      test_id: state.testDetails?.testId,
      practiceMode: state.testDetails?.practiceMode,
      gamification_status:
        state.testDetails?.practiceMode === "practice" &&
        state.testDetails?.gamificationOn
          ? 1
          : undefined,
    };

    const response = yield call(examApi.saveAnswer, finalPayload);
    yield put(saveAnswerSuccess(response));

//  STORE PRACTICE STREAK DATA (ONLY FOR PRACTICE MODE)
if (
  state.testDetails?.practiceMode === "practice" &&
  response?.question_answer_streak
) {
  yield put(setPracticeStreak(response.question_answer_streak));

}


    if (nextIndex < state.questionsData.length) {
      const nextQ = state.questionsData[nextIndex];

      const getSectionKey = (q) =>
        `${q.subject} ${q.section_name || ""}`.trim();

      if (getSectionKey(currentQ) !== getSectionKey(nextQ)) {
        yield put(setActiveSection(getSectionKey(nextQ)));
      }

      yield put(setCurrentQuestionIndex(nextIndex));

      yield put(
        fetchExamQuestionRequest({
          qid: nextQ.qid,
          paperId: nextQ.paper_id,
          testId: state.testDetails?.testId,
          setId: state.testDetails?.setId,
        })
      );
    }
  } catch (error) {
    yield put(saveAnswerFailure(error.message));
  }
}

/* ------------------ PRACTICE LIST ------------------ */
function* fetchPracticeListWorker() {
  try {
    const response = yield call(examApi.getPracticeList);
    yield put(fetchPracticeListSuccess(response.data.data));
  } catch (error) {
    yield put(fetchPracticeListFailure(error.message));
  }
}

/* ------------------ SUBMIT EXAM ------------------ */
function* submitExamWorker(action) {
  try {
    const { testDetails } = yield select((state) => state.examSlice);
    const isTopicWisePyq = !!testDetails?.setId;
    let payload;

    if (isTopicWisePyq) {
      payload = {
        paperType: action.payload.paperType,
        time: action.payload.time,
        setId: action.payload.setId,
        paperId: undefined,
        testId: undefined,
        plannerId: undefined,
      };
    } else {
      payload = {
        paperType: action.payload.paperType,
        paperId: action.payload.paperId,
        testId: testDetails?.testId,
        plannerId: action.payload.plannerId,
        time: action.payload.time,
      };
    }

    const response = yield call(examApi.submitExam, {
      ...payload,
      practiceMode: testDetails?.practiceMode,
      gamification_status:
        testDetails?.practiceMode === "practice" && testDetails?.gamificationOn
          ? 1
          : undefined,
    });

    yield put(submitExamSuccess(response));

    yield put(clearBasicAnalytics());
    yield put(setTimeLeft(null));

    if (testDetails?.practiceMode !== "practice") {
      yield delay(1500);
      yield put(fetchBasicAnalyticsRequest());
    }

    // localStorage.removeItem("exam_timeLeft");
    // localStorage.removeItem("exam_testId");
    const currentTestId =
  testDetails?.testId ||
  testDetails?.setId ||
  testDetails?.paperId;

const testKey = `exam_timeLeft_${currentTestId}`;
localStorage.removeItem(testKey);
  } catch (error) {
    yield put(submitExamFailure(error.message));
  }
}

function* fetchPyqYearWiseWorker(action) {
  try {
    const response = yield call(examApi.getPyqYearWise, action.payload);
    yield put(getPyqYearWiseSuccess(response.data));
  } catch (error) {
    yield put(getPyqYearWiseFailure(error.message));
  }
}

// function* fetchPyqYearwisePapersWorker(action) {
//   try {
//     const response = yield call(examApi.getPyqYearwisePapers, action.payload);
//     yield put(getPyqYearwisePapersSuccess(response.data));
//   } catch (error) {
//     yield put(getPyqYearwisePapersFailure(error.message));
//   }
// }
function* fetchPyqYearwisePapersWorker(action) {
  try {
    //  Get selectedType from Redux
    const selectedType = yield select(
      (state) => state.examSlice.selectedType
    );

    //  Convert to backend target
    const target = selectedType === "adv" ? 2 : 1;

    const response = yield call(examApi.getPyqYearwisePapers, {
      year: action.payload.year,
      target, //  always send correct target
    });

    yield put(getPyqYearwisePapersSuccess(response.data));
  } catch (error) {
    yield put(getPyqYearwisePapersFailure(error.message));
  }
}


function* fetchSubjectListWorker(action) {
  try {
    const response = yield call(examApi.subjectList, action.payload);
    yield put(fetchSubjectListSuccess(response));
  } catch (error) {
    yield put(fetchSubjectListFailure(error.message));
  }
}

function* saveBookmarkWorker(action) {
  try {
    const response = yield call(examApi.saveBookmark, action.payload);
    yield put(saveBookmarkSuccess(response));
  } catch (error) {
    yield put(saveBookmarkFailure(error.message));
  }
}

function* fetchPyqTopicWiseWorker(action) {
  try {
    const response = yield call(examApi.topicWise, action.payload);
    yield put(getPyqTopicWiseSuccess(response.data.subject));
  } catch (error) {
    yield put(getPyqTopicWiseFailure(error.message));
  }
}

function* fetchPyqSubjectWiseWorker(action) {
  try {
    const response = yield call(examApi.subjectWise, action.payload);
    yield put(getPyqSubjectWiseSuccess(response.data));
  } catch (error) {
    yield put(getPyqSubjectWiseFailure(error.message));
  }
}
function* fetchPracticeSummaryWorker(action) {
  try {
    const { paper_type, paper_id, set_id, gamification_status } =
      action.payload;

    const response = yield call(examApi.getPracticeSummary, {
      paperType: paper_type,
      paperId: paper_id,
      setId: set_id,
      gamification_status,
    });

    yield put(fetchPracticeSummarySuccess(response));
  } catch (error) {
    yield put(fetchPracticeSummaryFailure(error.message));
  }
}

function* fetchPyqTopicWiseSetsWorker(action) {
  try {
    const response = yield call(examApi.getPyqTopicWiseSets, action.payload);
    yield put(getPyqTopicWiseSetsSuccess(response));
  } catch (error) {
    yield put(getPyqTopicWiseSetsFailure(error.message));
  }
}

/* ------------------ ROOT SAGA ------------------ */
function* watchExamSaga() {
  yield takeLatest(
    fetchExamInstructionRequest.type,
    fetchExamInstructionWorker
  );
  yield takeLatest(fetchExamQuestionRequest.type, fetchExamQuestionWorker);
  yield takeLatest(
    fetchExamQuestionsListRequest.type,
    fetchExamQuestionsListWorker
  );
  yield takeLatest(saveAnswerRequest.type, saveAnswerWorker);
  yield takeLatest(submitExamRequest.type, submitExamWorker);
  yield takeLatest(fetchPracticeListRequest.type, fetchPracticeListWorker);

  yield takeLatest(getPyqYearWiseRequest.type, fetchPyqYearWiseWorker);
  yield takeLatest(
    getPyqYearwisePapersRequest.type,
    fetchPyqYearwisePapersWorker
  );
  yield takeLatest(fetchSubjectListRequest.type, fetchSubjectListWorker);
  yield takeLatest(saveBookmarkRequest.type, saveBookmarkWorker);
  yield takeLatest(getPyqTopicWiseRequest.type, fetchPyqTopicWiseWorker);
  yield takeLatest(getPyqSubjectWiseRequest.type, fetchPyqSubjectWiseWorker);
  yield takeLatest(
    getPyqTopicWiseSetsRequest.type,
    fetchPyqTopicWiseSetsWorker
  );
  yield takeLatest(
    fetchPracticeSummaryRequest.type,
    fetchPracticeSummaryWorker
  );
}

export default function* examSaga() {
  yield all([fork(watchExamSaga)]);
}
